module.exports = __webpack_public_path__ + "static/IOBuilders-d04066d9b109c446069e1a968680eabc.png";